import type { IParticipantModel } from '@treneo/models';
import { AvatarConsts } from '@treneo/shared/constants';

import { Avatar } from './avatar';
import { CircleImage } from './circle-image';

type Props = {
  displayName: string;
  color: string;
  avatarUrl?: IParticipantModel['avatarUrl'];
  avatarSize?: string;
};

export const UserAvatar = ({
  displayName,
  color,
  avatarUrl,
  avatarSize = AvatarConsts.defaultAvatarSize
}: Readonly<Props>) =>
  avatarUrl ? (
    <CircleImage src={avatarUrl} alt='User Avatar' size={avatarSize} />
  ) : (
    <Avatar displayName={displayName} color={color} size={avatarSize} />
  );
